import { createSlice } from "@reduxjs/toolkit";
import {
  connectYouTube,
  createYouTubePost,
  getYouTubePost,
  deleteYouTubePost,
  getYouTubeAuthUrl
} from "./thunk";

const initialState = {
  youtubeData: [],
  youtubeLoading: false,
  deleteLoading: false,
  authUrl: null,
  authLoading: false,
  isConnected: false,
  channelInfo: null
};

const youtubeSlice = createSlice({
  name: "youtube",
  initialState,
  reducers: {
    clearYouTubeData: (state) => {
      state.youtubeData = [];
      state.isConnected = false;
      state.channelInfo = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Get YouTube Auth URL
      .addCase(getYouTubeAuthUrl.pending, (state) => {
        state.authLoading = true;
      })
      .addCase(getYouTubeAuthUrl.fulfilled, (state, action) => {
        state.authLoading = false;
        state.authUrl = action.payload;
      })
      .addCase(getYouTubeAuthUrl.rejected, (state) => {
        state.authLoading = false;
        state.authUrl = null;
      })
      
      // Connect YouTube
      .addCase(connectYouTube.pending, (state) => {
        state.youtubeLoading = true;
      })
      .addCase(connectYouTube.fulfilled, (state, action) => {
        state.youtubeLoading = false;
        state.isConnected = true;
        state.channelInfo = action.payload.channelInfo;
      })
      .addCase(connectYouTube.rejected, (state) => {
        state.youtubeLoading = false;
        state.isConnected = false;
      })
      
      // Create YouTube Post
      .addCase(createYouTubePost.pending, (state) => {
        state.youtubeLoading = true;
      })
      .addCase(createYouTubePost.fulfilled, (state) => {
        state.youtubeLoading = false;
      })
      .addCase(createYouTubePost.rejected, (state) => {
        state.youtubeLoading = false;
      })
      
      // Get YouTube Posts
      .addCase(getYouTubePost.pending, (state) => {
        state.youtubeLoading = true;
      })
      .addCase(getYouTubePost.fulfilled, (state, action) => {
        state.youtubeLoading = false;
        state.youtubeData = action.payload;
      })
      .addCase(getYouTubePost.rejected, (state) => {
        state.youtubeLoading = false;
        state.youtubeData = [];
      })
      
      // Delete YouTube Post
      .addCase(deleteYouTubePost.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteYouTubePost.fulfilled, (state) => {
        state.deleteLoading = false;
      })
      .addCase(deleteYouTubePost.rejected, (state) => {
        state.deleteLoading = false;
      });
  },
});

export const { clearYouTubeData } = youtubeSlice.actions;
export default youtubeSlice.reducer;